import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

// eslint-disable-next-line no-unused-vars
export const channelGuideRequestBeacon = () => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.BACKGROUND,
  eventName: EVENT_NAMES.CHANNEL_GUIDE_REQUEST,
});
